import React from "react";
import get from "lodash/get";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import UnitInput from "../../../parts/inputs/unit-input";

function View(props, { locals }) {
  const { activeUser, units: activeUserUnits } = locals;

  return (
    <div className="Main Settings-Rep-Maximum">
      <SettingsNav />

      <div className="Content">
        <div className="frame alt">
          <form id="form-preferences" method="POST" data-noreset>
            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="label" style={{ marginBottom: "-10px" }}>
                  Rep Maximum (RM)
                </div>
              </div>

              <div className="column" data-col="1/3">
                <div className="label" style={{ color: "#8c479a" }}>
                  Squat
                </div>
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  className="text-input"
                  name="repMaximums[squat]"
                  placeholder=""
                  defaultValue={get(activeUser, "repMaximums.squat")}
                />
              </div>

              <div className="column" data-col="1/3">
                <div className="label" style={{ color: "#2482c5" }}>
                  Bench
                </div>
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  className="text-input"
                  name="repMaximums[bench]"
                  placeholder=""
                  defaultValue={get(activeUser, "repMaximums.bench")}
                />
              </div>

              <div className="column" data-col="1/3">
                <div className="label" style={{ color: "var(--red)" }}>
                  Deadlift
                </div>
                <UnitInput
                  required
                  min="1"
                  metric="kg"
                  imperial="lb"
                  className="text-input"
                  name="repMaximums[deadlift]"
                  placeholder=""
                  defaultValue={get(activeUser, "repMaximums.deadlift")}
                />
              </div>

              <div className="column" data-col="1/1">
                <p>
                  To update your Secondary RMs, manage your{" "}
                  <a href="/dashboard/settings/exercise-library">
                    Exercise Library.
                  </a>
                </p>
              </div>

              <div className="column" data-col="1/1">
                <button className="button-input" type="submit">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const RepMaximum = (app) => {
  app
    .get(
      "/rep-maximum",
      set("heading", "Rep Maximum"),
      ({ res }) => (res.body = <View />)
    )
    .post("/rep-maximum", async ({ req, locals, res, api, flash, assert }) => {
      const { units, activeUser } = locals;
      const { body } = req;
      const { redirect = "back" } = body;
      const { exerciseLibrary } = activeUser;

      // Globally update secondary RMs to be in line with new primary RM. MSB-429
      body.exerciseLibrary = activeUser.exerciseLibrary;
      for (let exercise in exerciseLibrary) {
        if (exercise !== "assistant") {
          get(exerciseLibrary, exercise, []).map((movement) => {
            if (!movement.customizedRM) {
              movement.repMaximum = body.repMaximums[exercise];
            }
          });
        }
      }

      assert(body.repMaximums, 400, "You must provide a 1RM");
      assert(
        body.repMaximums.squat > 0,
        400,
        "Squat 1RM must be greater than 0"
      );
      assert(
        body.repMaximums.bench > 0,
        400,
        "Bench 1RM must be greater than 0"
      );
      assert(
        body.repMaximums.deadlift > 0,
        400,
        "Deadlift 1RM must be greater than 0"
      );

      body.action = "updateUserPreferences";
      if (!isNew && confirm("Apply new 1 rep max to all upcoming workouts?")) {
        body.action = "updateFutureRM";
      }

      await api(`user/${locals.activeUser._id}`, { method: "PUT", body });
      flash("success", "Successfully updated");

      if (redirect === "back") res.backDontScroll();
      else res.redirect(redirect);
    });
};

export default RepMaximum;
